import { post, get } from '../index'
export default {
  // 订单提交
  postOrdersubmission (querys) {
    return post('/appstore/admin/getPlugListWeixinPay', querys)
  },
  // 获取支付二维码
  postOrderQRcode (querys) {
    return post('/appstore/admin/weixinpay', querys)
  },
  // 取消订单
  postcancelOrder (querys) {
    return post('/appstore/admin/cancelPlugListWeixinPay', querys)
  },
  // 获取支付列表
  postPaymentlist (querys) {
    return post('/appstore/admin/ReserveList', querys)
  },
  // 获取开票列表
  postBillinglist (querys) {
    return post('/appstore/admin/InvoiceList', querys)
  },
  // 开票申请
  postInvoiceapplication (querys) {
    return post('/appstore/admin/Invoice', querys)
  },
  // 到期状态
  getrenewalStatus (querys) {
    return get('/agent/user/renewalStatus', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/linepay.js